import { Directive, Input } from '@angular/core';

import { PlaceholderContext } from 'cms/cms-shared/cms-shared.model';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';
import { IdtComponentSettings, SlotSettings } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponent, PieceContainerType } from 'shared/models/idt-components/idt-component.models';


@Directive()
export class BaseWorkspaceComponent<T extends IdtComponentSettings>
  extends UnsubscribeComponent {

  @Input() public component!: IdtComponent<T>;
  @Input() public context!: PlaceholderContext;
  @Input() public country?: string;
  @Input() public lang?: string;
  @Input() public piece?: IdtComponent<T>;
  @Input() public settings!: T; // Used only by render components
  @Input() public slot?: SlotSettings;
  @Input() public type!: PieceContainerType;

}
